import React, { useState } from 'react';
import { Lock, Flame, Shield } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function SuperAdminLogin() {
  const { saLogin }         = useAuth();
  const navigate            = useNavigate();
  const [email, setEmail]   = useState('');
  const [pass, setPass]     = useState('');
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await saLogin(email, pass);
      navigate('/superadmin');
    } catch (err) {
      setError(err?.response?.data?.detail || 'Invalid super-admin credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-lg">
            <Flame size={20} className="text-black" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-black text-white text-lg tracking-tight leading-none">VAYUSARTHI</div>
            <div className="text-[10px] font-bold tracking-[0.15em] text-gray-500 uppercase">Super Admin</div>
          </div>
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-2xl p-8">
          <div className="flex items-center gap-2 mb-5">
            <Shield size={16} className="text-orange-400" />
            <span className="text-xs font-bold tracking-widest text-orange-400 uppercase">Admin Access</span>
          </div>
          <h1 className="font-black text-2xl text-white tracking-tight mb-1">Sign in</h1>
          <p className="text-gray-500 text-sm mb-6">Platform administrator credentials only.</p>

          {error && (
            <div className="mb-4 px-4 py-3 bg-red-900/40 border border-red-800 rounded-lg text-red-400 text-sm">
              {error}
            </div>
          )}

          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label className="text-[11px] font-bold tracking-widest text-gray-500 uppercase block mb-2">Email</label>
              <input
                className="w-full px-3.5 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm placeholder-gray-600
                           focus:outline-none focus:border-orange-500 transition-colors"
                type="email" placeholder="superadmin@lpgmanager.com"
                value={email} onChange={e => setEmail(e.target.value)} required
              />
            </div>
            <div>
              <label className="text-[11px] font-bold tracking-widest text-gray-500 uppercase block mb-2">Password</label>
              <input
                className="w-full px-3.5 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm placeholder-gray-600
                           focus:outline-none focus:border-orange-500 transition-colors"
                type="password" placeholder="••••••••"
                value={pass} onChange={e => setPass(e.target.value)} required
              />
            </div>
            <button
              type="submit" disabled={loading}
              className="w-full h-11 bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white font-semibold
                         rounded-lg flex items-center justify-center gap-2 text-sm transition-colors disabled:opacity-50"
            >
              <Lock size={15} />
              {loading ? 'Signing in…' : 'Access admin panel'}
            </button>
          </form>

          <p className="mt-5 text-center text-xs text-gray-600">
            <a href="/login" className="hover:text-gray-400 transition-colors">← Back to company login</a>
          </p>
        </div>
      </div>
    </div>
  );
}
